import React, { useEffect, useMemo, useState } from 'react';
import { Dimensions, FlatList, Platform, ScrollView, TouchableOpacity, View } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from '../NeedHelpDC';
import Typography from '../../typography/Typography';
import AssetDetails from '../AssetDetails';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { addCommasToNumber, getScreenType } from '../utils';
import BottomSheet from '../BottomSheet';
import { isMobile } from '../../stack/utils';
import HeaderDefaultBase from '../../header/HeaderDefault.Base';
import Button from '../../button/Button';
import Icon from '../../icon/Icon';
const ForeclosureCollateralDetails = ({ height, contactUsDetails, goBackAction, userData, triggerAction, pledgedData, fundValue, }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [list, setList] = useState({});
    const [flatData, setFlatData] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [filtersSections, setFiltersSection] = useState([]);
    const [filterName, setFilterName] = useState('EQUITY');
    const [getCollateralLoader, setShowGetCollateralLoader] = useState(false);
    let eligibleFilters = [];
    const setInitialData = () => {
        pledgedData.map((item) => {
            if (eligibleFilters.includes(item.assetSubType)) {
                // Do nothing basically
            }
            else {
                eligibleFilters.push(item.assetSubType);
            }
        });
        setFiltersSection(eligibleFilters);
    };
    useEffect(() => {
        setFlatData(pledgedData);
        setShowGetCollateralLoader(false);
        let listObj = {
            eligibleAssetData: pledgedData,
            nonEligibleAssetData: []
        };
        setInitialData();
        setList(listObj);
    }, [pledgedData]);
    useEffect(() => {
        let listObj = {
            eligibleAssetData: pledgedData,
            nonEligibleAssetData: []
        };
        setInitialData();
        setList(listObj);
    }, []);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Pledged mutual funds', needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const ChecklistItem = ({ item, onPress }) => {
        return (React.createElement(View, { style: {
                paddingVertical: 16,
                paddingLeft: 10,
                paddingRight: 15,
                justifyContent: 'center',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    alignContent: 'center',
                } },
                React.createElement(TouchableOpacity, { style: { paddingRight: 2, paddingLeft: 2 }, onPress: () => {
                        let data = selectedList;
                        const index = data.indexOf(item.isinCode);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isinCode);
                        }
                        setSelectedList(data);
                        setFilterData(pledgedData.filter((item) => item.assetSubType === filterName));
                    } },
                    React.createElement(Icon, { name: selectedList.includes(item.isinCode)
                            ? IconTokens.CheckedSquare
                            : IconTokens.NotCheckedSquare, size: IconSizeTokens.XXL })),
                React.createElement(TouchableOpacity, { onPress: () => {
                        let data = selectedList;
                        const index = data.indexOf(item.isinCode);
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                        else {
                            data.push(item.isinCode);
                        }
                        setSelectedList(data);
                        setFilterData(pledgedData.filter((item) => item.assetSubType === filterName));
                    }, style: { width: '100%', marginLeft: 8, paddingRight: 16 } },
                    React.createElement(Typography, { label: item.assetName, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Night })))));
    };
    const returnFilter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { height: Platform.OS === "ios" ? height - 25 : height - 45, zIndex: 1 } },
            React.createElement(View, null,
                React.createElement(HeaderDefaultBase, { title: 'Filters' })),
            React.createElement(View, { style: height ? {
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                    ...Platform.OS === 'ios' && {
                        height: height ? height - 56 : '100%'
                    },
                    ...Platform.OS !== 'ios' && {
                        flex: 1
                    },
                } : {
                    flex: 1,
                    flexDirection: 'row',
                    borderTopWidth: 1,
                    borderColor: '#E4E7EC',
                } },
                React.createElement(FlatList, { style: {
                        width: 150,
                        backgroundColor: '#F9FAFB',
                    }, ItemSeparatorComponent: () => (React.createElement(View, { style: {
                            backgroundColor: '#E4E7EC',
                            height: 1,
                        } })), data: filtersSections, renderItem: ({ item }) => (React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                padding: 20,
                            }, onPress: () => {
                                setFilterData(pledgedData.filter((items) => items.assetSubType === item));
                                setFilterName(item);
                            } }, React.createElement(Typography, { label: item, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter })))) }),
                React.createElement(View, { style: {
                        width: 1,
                        height: '100%',
                        backgroundColor: '#E4E7EC',
                    } }),
                React.createElement(View, { style: {
                        flex: 1,
                    } },
                    React.createElement(ScrollView, { nestedScrollEnabled: true, style: height ? {
                            flex: 1,
                            paddingBottom: Platform.OS === 'ios' ? 80 : 16,
                            paddingHorizontal: 16
                        } : { height: 550 } }, filterData.map((item) => {
                        return (React.createElement(View, null,
                            React.createElement(ChecklistItem, { item: item, onPress: () => {
                                } }),
                            React.createElement(View, { style: { backgroundColor: '#E4E7EC', height: 1 } })));
                    })),
                    React.createElement(View, { style: {
                            height: 56
                        } }))),
            React.createElement(View, { style: {
                    height: Platform.OS === 'ios' ? 76 : 88,
                    position: "absolute",
                    bottom: Platform.OS !== 'ios' ? -5 : 0,
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderWidth: 1,
                    borderColor: '#ddd',
                    borderBottomWidth: 0,
                    elevation: 5,
                    paddingTop: 16,
                    paddingBottom: 16,
                    paddingHorizontal: 16,
                    ...Platform.OS === "ios" && { paddingBottom: 6 }
                } },
                React.createElement(View, { nativeID: 'bt_pledgeMf_resetFilter', style: { flex: 0.5, marginRight: 8 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: "Reset filter", fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setSelectedList([]);
                            let listObj = {
                                eligibleAssetData: pledgedData,
                                nonEligibleAssetData: []
                            };
                            setFlatData(pledgedData);
                            setList(listObj);
                            return;
                        } })),
                React.createElement(View, { nativeID: 'bt_pledgeMf_apply', style: { flex: 0.5 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, label: "Apply", onPress: () => {
                            applyFilter();
                            setShowFilter(false);
                        } })))));
    };
    const applyFilter = () => {
        let filteredData = [];
        if (selectedList.length === 0) {
            let listObj = {
                eligibleAssetData: pledgedData,
                nonEligibleAssetData: []
            };
            setFlatData(filteredData);
            setList(listObj);
            setFlatData(pledgedData);
            return;
        }
        pledgedData.map((item) => {
            selectedList.includes(item.isinCode)
                ? filteredData.push(item)
                : null;
        });
        let listObj = {
            eligibleAssetData: filteredData,
            nonEligibleAssetData: []
        };
        setFlatData(filteredData);
        setList(listObj);
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { marginTop: 24 } },
            React.createElement(View, { style: { marginHorizontal: 16, padding: 20, backgroundColor: 'white', borderRadius: 12, borderColor: '#E4E7EC', borderWidth: 1 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Mutual fund value', color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginTop: 2 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0B, label: `₹${addCommasToNumber(fundValue)}`, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(View, { style: { marginTop: 24, backgroundColor: 'white' } },
                React.createElement(ScrollView, { style: {
                        flex: 1,
                    } },
                    React.createElement(AssetDetails, { data: [selectedList], dataa: list, flatData: flatData, onFitlerSet: () => {
                            setShowFilter(true);
                            setFilterData(pledgedData.filter((item) => item.assetSubType === filtersSections[0]));
                            setFilterName(filtersSections[0]);
                        }, isFromEligible: true, triggerAction: triggerAction, height: height, isFromForeclosure: true })))));
    };
    const showFilteredList = () => {
        return showFilter && React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99,
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: true, height: height - 50, width: '100%', closeFunction: () => {
                    setShowFilter(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS === 'ios' ? Dimensions.get('window').height + 5 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 506, routeId: "routeId", handleKeyboard: true }, returnFilter()));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.Primary_05, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })),
            showFilteredList()) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default ForeclosureCollateralDetails;
